module.exports = __webpack_public_path__ + "img/logo-full.82572f1b.png";